var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.11 327.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.31,338.69H87c-6.12-1.29-12.41-2.05-18.33-4-34.38-11.18-56.91-42.07-57-78.35q-.23-81.28,0-162.58C11.67,76.26,16.56,60.14,27,46,43.92,23,66.92,11.6,95.46,11.57q79-.06,158.08,0a92.9,92.9,0,0,1,16.51,1.24c30.23,5.49,51.31,22.67,62.83,51,3,7.27,3.93,15.35,5.81,23.06V263.3c-.4,2.28-.79,4.57-1.22,6.85-5.65,30-22.67,51.05-50.81,62.63C279.31,335.81,271.12,336.78,263.31,338.69Zm47.93-163.56h.12c0-26.62,0-53.23,0-79.85,0-8.53-1.12-16.82-4.93-24.48C296.14,50,279.31,39,256.05,38.93c-54-.19-108-.07-161.92,0a67.61,67.61,0,0,0-9.52.75c-24.77,3.49-45.28,25.89-45.45,51C38.8,146.31,39,202,39,257.68a48.27,48.27,0,0,0,4.81,21.63c10.46,21.19,27.61,32,51.27,32.05q80,.11,160,0a81.35,81.35,0,0,0,10.8-.77c24.29-3.33,44.95-26,45.28-50.49C311.54,231.78,311.24,203.45,311.24,175.13Z",
    transform: "translate(-11.58 -11.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.79,256.9c-45.26-.39-81.92-37.46-81.38-82.3C94,129.35,130.71,93,175.52,93.35c45.26.38,81.93,37.45,81.39,82.29C256.36,220.87,219.57,257.28,174.79,256.9Zm.43-27.33a54.45,54.45,0,1,0-54.5-54.3A54.35,54.35,0,0,0,175.22,229.57Z",
    transform: "translate(-11.58 -11.54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.6,106.87a20.39,20.39,0,0,1,.3-40.77,20.39,20.39,0,1,1-.3,40.77Z",
    transform: "translate(-11.58 -11.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramDark);
export default __webpack_public_path__ + "static/media/instagram_dark.71c9b2a2493d27fe76db3e6c7796d1ad.svg";
export { ForwardRef as ReactComponent };